import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ThemeComponent } from './theme/theme.component';
import { LayoutModule } from './theme/layouts/layout.module';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ScriptLoaderService } from "./_services/script-loader.service";
import { ThemeRoutingModule } from "./theme/theme-routing.module";
import { AuthModule } from "./auth/auth.module";
import { AppService } from './app.service';
import { ApiService } from './theme/pages/api-service.service';
// import { HashLocationStrategy, LocationStrategy } from '@angular/common';
// import { Configuration } from './configuration';
import { PagingService } from './_services/pagination.service';

@NgModule({
    declarations: [
        ThemeComponent,
        AppComponent
        
    ],
    imports: [
        LayoutModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        ThemeRoutingModule,
        AuthModule,
    ],
    providers: [ScriptLoaderService,AppService,ApiService,PagingService],
        // {provide: LocationStrategy, useClass: HashLocationStrategy}],
    bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// D:/Finca/Finca UI/UI/src/app/app.module.ts